module.exports = __webpack_public_path__ + "static/img/creative.c6a0bd04.png";